import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ServiceEvent, ServiceEventEntity, ServiceEventLocationFacet} from "../../../model/service/service-event";

export interface ServiceEventSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<ServiceEventSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const serviceEventsSelector = () => createSelector(
  [getUseQueryResultData<ServiceEvent[]>, getRegionIdParam],
  (data, regionId) => {
    return selectServiceEventsAndTransform(
      data ?? [], {regionId: regionId}
    );
  }
);

export const serviceEventSelector = () => createSelector(
  [getUseQueryResultData<ServiceEvent>],
  (data) => {
    return data ? transformServiceEvent(data) : undefined;
  }
);

export const selectServiceEvents = (values?: ServiceEvent[], selector?: ServiceEventSelectorProps): ServiceEvent[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformServiceEvent = (value: ServiceEvent): ServiceEventEntity => {
  return ServiceEventEntity.from(value)
}

export const selectServiceEventsAndTransform = (values?: ServiceEvent[], selector?: ServiceEventSelectorProps): ServiceEventEntity[] => {
  const selected = selectServiceEvents(values, selector);
  return selected.map(transformServiceEvent);
};

export const serviceEventLocationFacetsSelector = () => createSelector(
  [getUseQueryResultData<ServiceEventLocationFacet[]>],
  (data) => {
    return data ?? []
  }
);
